<modal-panel title="Filter ADX Service Bus Monitor" (close)="close()">
  <div class="filter" [formGroup]="form">
    <div class="filter__fields" [class.two-col]="!isSmall">

      <mat-form-field>
        <mat-label>From</mat-label>
        <input matInput readonly [matDatepicker]="from" formControlName="From"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #from/>
        <mat-datepicker-toggle matIconSuffix [for]="from"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>To</mat-label>
        <input matInput readonly [matDatepicker]="to" formControlName="To"/>
        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker #to/>
        <mat-datepicker-toggle matIconSuffix [for]="to"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Single Day</mat-label>
        <input matInput readonly [matDatepicker]="day" formControlName="Day"/>
        <mat-hint>Restrict to one issue date</mat-hint>
        <mat-datepicker #day/>
        <mat-datepicker-toggle matIconSuffix [for]="day"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Record Locator (ADX Ref)</mat-label>
        <input matInput formControlName="RecordLocator" placeholder="e.g. 1QL7P3"/>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Date Basis (daily totals)</mat-label>
        <mat-select formControlName="DateBasis">
          <mat-option value="Issue">Issue Date (business)</mat-option>
          <mat-option value="Created">Created Date (ingestion)</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="filter__toggle">
        <mat-slide-toggle formControlName="OnlyMismatches">Only Mismatches</mat-slide-toggle>
      </div>

    </div>
  </div>
  <ng-container modalPanelFooter>
    <button mat-button (click)="reset()">Reset</button>
    <button mat-raised-button color="primary" (click)="apply()">Apply</button>
  </ng-container>
</modal-panel>
